import * as actions from "../actions/Type";
const intialState = {
  add_todo: {},
  items: [],
  checked: {},
  list_of_rent_property: [],
  // hr
  list_requests: [],
  request_view: {},
  hr_forms: [],
  view_hr_form: {},
};
const TodoAppReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.ADD_TODO_APP:
      return {
        ...state,
        add_todo: action.payload,
      };
    case actions.GET_LIST_TODO_APP:
      return {
        ...state,
        items: action.payload,
      };
    case actions.UPDATEING_TODO_APP_CHECKBOX:
      return {
        ...state,
      };

    case actions.DELETE_TODO_APP_CHECKBOX:
      return {
        ...state,
      };
    case actions.DELETE_TODO_AGENT_BRANCH:
      return {
        ...state,
        items: state.items.filter((el) => el._id !== action.id_todo),
      };
    // hr
    case actions.GET_REQUEST_LISTS:
      return {
        ...state,
        list_requests: action.payload,
      };
    case actions.VIEW_REQUESTS:
      return {
        ...state,
        request_view: action.payload,
      };
    case actions.ACTIVE_REQUESTS:
      return {
        ...state,
      };
    case actions.HR_FORM_REQUESTS:
      return {
        ...state,
        hr_forms: action.payload,
      };
    case actions.VIEW_HR_FORM_REQUESTS:
      return {
        ...state,
        view_hr_form: action.payload,
      };
    default:
      return { ...state };
  }
};

export default TodoAppReducer;
